import { apiOperations } from '../../config/api'

const operationsService = {
  get: async (userToken, pageSize, pageNumber) => {
    const { data } = await apiOperations.get(
      'retrieve/1.0/prc_ListadoPrestamos_v4',
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
          'Ocp-Apim-Subscription-Key':
            process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY,
        },
      },
    )
    return data
  },
  postOne: async (id, bankOperation, userToken) => {
    const { data } = await apiOperations.post(
      'loan-detail/retrieve/1.0/prc_DetallePrestamo_v4',
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
          'Ocp-Apim-Subscription-Key':
            process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY,
          LoanNumber: bankOperation,
          bankOperation: id,
        },
      },
    )
    return data
  },
  getDocuments: async () => {
    const {
      data: { data: result },
    } = await apiOperations.get(`list-documents/prc_PrestamoDocumentos_v3`)
    return result
  },
  getRequests: async (idUser) => {
    const {
      data: { data: result },
    } = await apiOperations.get(
      `modificationrequest/getrequestlistquery/${idUser}`,
    )
    return result
  },
}
export default operationsService
